'use strict';

class ScrolledPage {

    
    constructor() {
        
        const body = document.querySelector('body');

        let observer = new IntersectionObserver(entries => {
            
            if (entries[0].boundingClientRect.y < 0) {

                body.classList.add('scrolled');

            } else {

                body.classList.remove('scrolled');
                
            }
        });
        observer.observe(document.getElementById('scroll-detect'));

    }

}

module.exports = ScrolledPage;
